import { CommonModule } from '@angular/common';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import {
  GcButtonComponent,
  GcIconComponent,
  GcLoadingSpinnerComponent,
  GcModalComponent,
  GcTextComponent,
  IpoFlexibleTableModule,
  IpoLanguageService,
  IpoStringService,
  IpoTranslateArrayPipe,
  IpoTranslatePipe,
  stringServiceFactory,
} from '@ip-only/front-end-library';
import { ErrorInformationComponent } from '../shared/error-information/error-information.component';
import { SharedModule } from '../shared/shared.module';
import { IdMapperPipeModule } from '../shared/util/id-mapper.pipe';
import { ConstructionDocumentsRoutingModule } from './construction-documents-app-routing.module';
import { ConstructionDocumentsWrapperComponent } from './construction-documents-wrapper/construction-documents-wrapper.component';
import { ConstructionDocumentsComponent } from './construction-documents/construction-documents.component';
import { DownloadFileConfirmationModalComponent } from './construction-documents/download-file-confirmation-modal/download-file-confirmation-modal.component';
import { FolderContentDesktopComponent } from './construction-documents/folder-content-desktop/folder-content-desktop.component';
import { FolderContentMobileComponent } from './construction-documents/folder-content-mobile/folder-content-mobile.component';
import { FolderContentWrapperComponent } from './construction-documents/folder-content-wrapper/folder-content-wrapper.component';
import en from './strings.en';
import fi from './strings.fi';
import sv from './strings.sv';

@NgModule({
  declarations: [
    ConstructionDocumentsComponent,
    FolderContentWrapperComponent,
    FolderContentMobileComponent,
    FolderContentDesktopComponent,
    DownloadFileConfirmationModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ConstructionDocumentsRoutingModule,
    IpoTranslatePipe,
    GcTextComponent,
    GcIconComponent,
    IpoFlexibleTableModule,
    IdMapperPipeModule,
    IpoTranslateArrayPipe,
    GcLoadingSpinnerComponent,
    GcModalComponent,
    ErrorInformationComponent,
    ConstructionDocumentsWrapperComponent,
    GcButtonComponent,
  ],
  providers: [
    {
      provide: IpoStringService,
      useFactory: stringServiceFactory({ en, sv, fi }),
      deps: [IpoLanguageService],
    },
    HttpClient,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class ConstructionDocumentsAppModule {}
